export  default {
    getDeviceTypes(state) {
        return state.deviceTypes;
    },
    getCurrentDeviceType(state) {
        return state.currentDeviceType;
    },
};